import CachedIcon from '@mui/icons-material/Cached';
import EditIcon from '@mui/icons-material/Edit';
import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges';
import { Card, CardContent, CardHeader, CircularProgress, IconButton, Typography } from "@mui/material";
import * as React from "react";
import { connect } from "react-redux";
import { ConnectionConfigInfoModel } from "../../../models";
import { actionCreators, ApplicationState, FetchState, selectors } from "../../../store";
import FetchHelper from '../../FetchHelper';
import { disabledRefreshAllBtnStyle, disabledRefreshSuccessIconStyles, enableRefreshAllBtnStyle, enableRefreshSuccessIconStyles, pollingColStyle, pollingColStyleTitle } from '../../styles';
import ConnectionConfigInfo_TJ360VersionDeviceDialog from './ConnectionConfigInfo_TJ360VersionDeviceDialog';
import { formatDateTime } from '../../../utils';

const params = {
    mainid: "",
    isRefreshAllBegin: 0,
    loadingRefreshAll: [false],
    isRefreshGroup: false,
    isDisbleRefeshBtn: true,
    isDisbleUpdateBtn: true,
    isEdit: false,
    centralId: "",
    deviceNo: "",
    isRefreshAllCompleted: (status: number) => { },
    setDisabledRefreshGroupBtn: (disabled: boolean, name: string) => { },
    setRefreshGroup: (refreshGroup: boolean, name: string) => { },
    setIsEdit: (isEdit: boolean) => { },
}

type Cpn30MinutePowerConsumptionProps = {
    defaultData: ConnectionConfigInfoModel | undefined;
    isRefreshSuccessDeviceNo?: boolean;
    onRefreshComplete?: () => void;
};

export type PureCpn30MinutePowerConsumptionProps = Cpn30MinutePowerConsumptionProps & ReturnType<typeof mapStateToProps> &
    typeof mapDispatchToProps & typeof params;

const fetchId = "CONNECTION_CONFIG_INFO_FETCH";
const updateConfirmTimeFetchId = "UPDATE_CONNECTION_CONFIG_INFO_FETCH_ID";
export const ConnectionConfigInfo_TJ360VersionDevice = (props: PureCpn30MinutePowerConsumptionProps) => {
    const { defaultData, fetchState, mainid, isRefreshAllBegin, loadingRefreshAll, isRefreshGroup, isDisbleRefeshBtn, isDisbleUpdateBtn, isEdit, centralId, deviceNo, isRefreshSuccessDeviceNo } = props;
    const { onUpdateError, onUpdateSuccess, onError, onRefresh, isRefreshAllCompleted, setDisabledRefreshGroupBtn, setRefreshGroup, onUpdate, setIsEdit } = props;
    const [connectionConfigInfo, setConnectionConfigInfo] = React.useState<ConnectionConfigInfoModel|null>(props.fetchState.data);
    const [refreshFlg, setRefreshFlg] = React.useState(false);
    const [isRefreshSuccess, setIsRefreshSuccess] = React.useState(false);
    const [editFlg, setEditFlg] = React.useState<boolean>(false);
    const [openDialog,setOpenDialog] = React.useState<boolean>(false);
    const [updateLoading, setUpdateLoading] = React.useState(false);
    const [updateData, setUpdateData] = React.useState<any>();

    React.useEffect(() => {
        if(!isRefreshSuccessDeviceNo)
            setIsRefreshSuccess(false);
    }, [isRefreshSuccessDeviceNo]);
    
    // パラメータ設定
    const handleFetchParams = () => {
        const params = new Map<string, any>();
        const code = "QJ";
        params.set("code", code);
        params.set("mainid", mainid);
        params.set("centralid", centralId);
        params.set("device_no", deviceNo);
        return params;
    }

    // デマンド現在値取得成功時
    const handleFetchSuccess = (data: any, action: string, isClickedRefreshBtn: boolean) => {
        setUpdateLoading(false);
        setEditFlg(false);
        const resData = {
            mainid: data.mainid,
            deviceNo: data.device_no,
            parentOrChild: data.parent_or_child,
            panId: data.pan_id,
            extendPanId: data.extend_pan_id,
            lastGetDatetime: data.last_get_datetime,
        } as ConnectionConfigInfoModel;
        setConnectionConfigInfo(resData);
        action === "edit" && setOpenDialog(true);
        setRefreshGroup(false, fetchId);
        isClickedRefreshBtn && setIsRefreshSuccess(true);
    };

    const handleError = (success: boolean, data: any, error: any) => {
        setEditFlg(false);
        onError(success, data, error);
        if (isRefreshAllBegin > 0) {
            isRefreshAllCompleted(isRefreshAllBegin + 1);
        }
        setRefreshGroup(false, fetchId);
        setIsRefreshSuccess(false);
    }

    const handleRefresh = () => {
        setIsRefreshSuccess(false);
        const params = handleFetchParams();
        onRefresh(params);
    };

    const handleRefreshSuccess = (data: any, fetchId: string) => {
        editFlg ? handleFetchSuccess(data, 'edit', true) : handleFetchSuccess(data, 'view', true);
        if (isRefreshAllBegin !== 0) {
            isRefreshAllCompleted(isRefreshAllBegin + 1);
        }
        props.onRefreshComplete?.();
    }

    const refreshAll = () => {
        if (isRefreshGroup) {
            handleRefresh();
            setIsRefreshSuccess(false);
        }
        isRefreshAllBegin > 0 || isRefreshGroup ? setRefreshFlg(true) : setRefreshFlg(false);
    }

    const handleEdit = () => {
        setEditFlg(true);
        const params = handleFetchParams();
        onRefresh(params);
        setIsRefreshSuccess(false);
    };

    const handleEditOk = (request:any) => {
        setOpenDialog(false);
        setUpdateLoading(true);
        const requestData = {
            centralid: centralId,
            device_no: request.deviceNo,
            extend_pan_id: request.extendPanId,
            mainid: request.mainid,
            pan_id: request.panId,
            parent_or_child: request.parentOrChild,
        }
        onUpdate(requestData);
        setUpdateData(requestData);
        setIsRefreshSuccess(false);
    }

    const handleUpdateSuccess = (success:any, data:any, error:any) => {
        const result = {
            mainid: data.mainid,
            resultCode: data.result_code,
            lastGetDatetime: data.last_get_datetime,
        };
        if (result.resultCode === '0') {
            onUpdateSuccess();
            handleFetchSuccess({...updateData, last_get_datetime: formatDateTime(new Date()) }, 'view', true);
        } else {
            handleUpdateError(success, data, error);
        }
    }

    const handleUpdateError = (success: boolean, data: any, error: any) => {
        onUpdateError(success, data, error);
        setUpdateLoading(false);
        setEditFlg(false);
        setIsRefreshSuccess(true);
    }

    // eslint-disable-next-line
    React.useEffect(refreshAll, [isRefreshAllBegin, isRefreshGroup]);

    React.useEffect(() => {
        setIsEdit(editFlg);
        // eslint-disable-next-line
    }, [editFlg]);

    React.useEffect(() => {
        setDisabledRefreshGroupBtn(fetchState.loading || updateLoading, fetchId);
        // eslint-disable-next-line
    }, [updateLoading, fetchState.loading]);

    React.useEffect(() => {
        defaultData && handleFetchSuccess(defaultData, 'view', false);
        if(!defaultData) {
            setConnectionConfigInfo(null);
        }
        // eslint-disable-next-line
    }, [defaultData]);

    return (
        <>
            <Card style={{ margin: '0 auto 12px', backgroundColor: '#f5faff', width: '100%' }}>
                <CardHeader
                    avatar={
                        <PublishedWithChangesIcon style={isRefreshSuccess ? enableRefreshSuccessIconStyles : disabledRefreshSuccessIconStyles} />
                    }
                    action={
                        <div>
                            <IconButton aria-label="edit" onClick={handleEdit} disabled={isDisbleUpdateBtn || isEdit || fetchState.loading || refreshFlg || updateLoading}>
                                <EditIcon fontSize="medium" style={isDisbleUpdateBtn || isEdit === true || refreshFlg || updateLoading || fetchState.loading ? disabledRefreshAllBtnStyle : enableRefreshAllBtnStyle} />
                            </IconButton>
                            <IconButton aria-label="refresh" onClick={handleRefresh} disabled={isDisbleRefeshBtn || refreshFlg || updateLoading || editFlg || fetchState.loading}>
                                <CachedIcon fontSize="medium" style={isDisbleRefeshBtn || refreshFlg || updateLoading || editFlg || fetchState.loading ? disabledRefreshAllBtnStyle : enableRefreshAllBtnStyle} />
                            </IconButton>
                        </div>
                    }
                    title='Connection設定情報'
                    titleTypographyProps={{ variant: 'h5' }}
                />
                <CardContent style={{ padding: '0 0 16px 0' }}>
                    {(fetchState.loading || updateLoading) ? (
                        <div style={{ display: 'flex', position: 'relative' }}>
                            <table className='polling' style={{ borderCollapse: 'collapse', width: '100%', margin: 'auto' }}>
                                <tbody>
                                    <tr>
                                        <td style={pollingColStyleTitle}>親機/子機設定</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>PAN ID</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>Extend PAN ID</td>
                                    </tr>
                                </tbody>
                            </table>
                            <div style={{ position: 'absolute', top: '40%', left: '60%' }}>
                                <CircularProgress style={{ margin: 'auto' }} />
                            </div>
                        </div>
                    ) : (
                        <table className='polling' style={{ borderCollapse: 'collapse', width: '100%', margin: 'auto' }}>
                            <tbody>
                                <tr>
                                    <td style={pollingColStyleTitle}>親機/子機設定</td>
                                    <td style={pollingColStyle}>{connectionConfigInfo?.parentOrChild == '0' ? 'Gateway' : connectionConfigInfo?.parentOrChild == '1' ? 'Peripheral' : ''}</td>
                                </tr>
                                <tr>
                                    <td style={pollingColStyleTitle}>PAN ID</td>
                                    <td style={pollingColStyle}>{connectionConfigInfo?.panId ?? ''}</td>
                                </tr>
                                <tr>
                                    <td style={pollingColStyleTitle}>Extend PAN ID</td>
                                    <td style={pollingColStyle}>{connectionConfigInfo?.extendPanId ?? ''}</td>
                                </tr>
                            </tbody>
                        </table>
                    )}
                    <Typography display='flex' justifyContent='flex-end' padding='4px 4px 0 0'>最終取得日時：{connectionConfigInfo?.lastGetDatetime ?? '-'}</Typography>
                </CardContent>
            </Card >

            {
                openDialog ? (
                    <>
                        <ConnectionConfigInfo_TJ360VersionDeviceDialog
                            onOK={(data) => {
                                handleEditOk(data);                            
                            }}
                            onCancel={() => {
                                setOpenDialog(false);
                            }}
                            data={connectionConfigInfo}
                            isOpen={openDialog}
                        />
                    </>
                ) : (
                    <div />
                )
            }
            <FetchHelper fetchId={fetchId} onComplete={(success, data, error) => success ? handleRefreshSuccess(data, fetchId) : handleError(success, data, error)} />
            <FetchHelper fetchId={updateConfirmTimeFetchId} onComplete={(success, data, error) => success ? handleUpdateSuccess(success, data, error) : handleUpdateError(success, data, error)} />
        </>
    );
};

const mapStateToProps = (state: ApplicationState) => ({
    fetchState: selectors.getFetchState(
        state,
        fetchId
    ) as FetchState,
});

const mapDispatchToProps = {
    onRefresh: (params: any) => actionCreators.fetch(fetchId, `/polling-nrf/get`, "GET", params),
    onUpdate: (data: any) => actionCreators.fetch(updateConfirmTimeFetchId, `/polling-nrf/set?code=QK`, 'POST', data, false, true),
    onError: (success: boolean, data: any, error: any) =>
        actionCreators.showMessage({
            type: "error",
            title: "Connection設定情報取得",
            body: "Connection設定情報取得できませんでした。",
        }),
    onUpdateSuccess: () =>
        actionCreators.showMessage({
            type: "info",
            title: "Connection設定情報変更",
            body: "Connection設定情報を更新しました。",
        }),
    onUpdateError: (success: boolean, data: any, error: any) =>
        actionCreators.showMessage({
            type: "error",
            title: "Connection設定情報変更",
            body: "Connection設定情報を変更できませんでした。",
        }),
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ConnectionConfigInfo_TJ360VersionDevice);


